import { render, staticRenderFns } from "./ChatConfigurationForm.vue?vue&type=template&id=59dc4c8a&lang=pug&"
import script from "./ChatConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./ChatConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatConfigurationForm.vue"
export default component.exports